import hyperdom from 'hyperdom'
import autocompleter from 'autocompleter'
const KEY_TAB = 9

export default function autocomplete (options) {
  const binding = hyperdom.binding(options.binding)
  let suggestionTimeout

  return hyperdom.viewComponent({
    onupdate () {
      this.suggestions = options.suggestions
    },

    onadd (el) {
      const clickSelected = () => {
        const selected = document.querySelector('.autocomplete .selected')
        selected && selected.click()
      }
      el.addEventListener('keydown', (e) => e.keyCode === KEY_TAB && clickSelected())
      el.addEventListener('blur', (e) => e.keyCode === KEY_TAB && clickSelected())
      this.suggestions = options.suggestions

      const {destroy: destroyAutocompleter} = autocompleter({
        input: el,
        className: ['be-autocomplete', options.testClass].filter(Boolean).join(' '),
        fetch: (value, done) => {
          if (suggestionTimeout) {
            clearTimeout(suggestionTimeout)
          }
          const suggestions = this.suggestions
          const totalSuggestions = suggestions.length
          const batchSize = 100
          const failSafe = 1000
          let matches = []
          let totalSearched = 0
          let batches = 0

          const filter = suggestion => {
            if (value.length >= 2) {
              value = value.toLowerCase()
              suggestion = suggestion.toLowerCase()
              return suggestion.indexOf(value) !== -1
            }
            return false
          }

          const filterNextBatch = () => {
            batches++
            const batch = suggestions.slice(totalSearched, totalSearched + batchSize)
            matches = matches.concat(batch.filter(filter))
            totalSearched = totalSearched + batch.length

            if (totalSearched >= totalSuggestions || batches > failSafe) {
              done(matches.map(x => ({label: x, value: x})))
            } else {
              suggestionTimeout = setTimeout(filterNextBatch, 0)
            }
          }
          filterNextBatch()
        },
        onSelect: (item, input) => {
          input.value = item.label
          binding.set(item.label)
          options.validate()
          this.refresh()
        },
      })
      this.onremove = () => destroyAutocompleter()
    },

    render () {
      return <input
        type='text'
        id={options.id}
        placeholder={options.placeholder}
        binding={binding}
        class='o-form-item__txt-input'
        onkeydown={options.onkeydown}
        autocomplete="off"
      />
    },
  })
}
